export default __webpack_public_path__ + "static/media/lyon-stEx.8dc9e0c2.webp";